<template>
<div>
    <div class="modal-title">
        <h2 class="alterar-senha modal-dinamic">Alterar Senha</h2>
        <h2 class="excluir-conta modal-dinamic">Excluir conta</h2>
        <h2 class="cancelar-gestao modal-dinamic">Cancelar Assinatura</h2>
        <h2 class="aviso-assinatura modal-dinamic">Assinatura Ativa</h2>
    </div>
    <div id="body" class="modal-body">
        <p class="excluir-conta modal-dinamic"> Essa é uma ação permanente e todos seus dados serão apagados. Tem certeza que deseja exlcuir sua conta ?</p>
        <form class="excluir-conta modal-dinamic">
            <div class="form-group">
                <label for="motive">Poderia nos informar o motivo?</label>
                <input class="form-control" type="text" id="motive" v-model="reason">
            </div>
            <div class="form-group">
                <label for="password">Insira sua senha</label>
                <input class="form-control" type="password" id="password">
            </div>
        </form>
        <form class="alterar-senha modal-dinamic" action="">
            <div class="form-group">
                <label for="newPassword">Insira sua nova senha</label>
                <input class="form-control" type="password" id="newPassword" v-model="newPassword">
            </div>
            <div class="form-group">
                <label for="newPasswordConfirmation">Confirme a senha</label>
                <input class="form-control"
                       type="password"
                       id="newPasswordConfirmation"
                       v-model="newPasswordConfirmation"
                >
            </div>
        </form>
        <p class="cancelar-gestao modal-dinamic"> Essa é uma ação permanente e todos seus dados referente ao seu plano serão apagados. Tem certeza que deseja cancelar sua assinatura ?</p>
        <form class="cancelar-gestao modal-dinamic">
            <div class="form-group">
                <label for="motive">Poderia nos informar o motivo?</label>
                <input class="form-control" type="text" id="motive" v-model="reason">
            </div>
        </form>
        <p class="aviso-assinatura modal-dinamic"> Por favor, antes de excluir sua conta, cancele a sua assinatura atual.</p>
    </div>
    <div class="modal-footer">
        <div class="excluir-conta modal-dinamic">
            <button @click="closeModal" class="btn btn-md btn-gray">Cancelar</button>
            <button @click="deleteAccount"
                    :disabled="passwordIsMatching"
                    class="btn btn-md btn-danger">
                        Excluir minha conta
            </button>
        </div>
        <div class="alterar-senha modal-dinamic">
            <button @click="closeModal" class="btn btn-md btn-gray">Cancelar</button>
            <button @click="changePassword"
                class="btn btn-md btn-primary">
                    Alterar
            </button>
        </div>
        <div class="cancelar-gestao modal-dinamic">
            <button @click="closeModal" class="btn btn-md btn-gray">Cancelar</button>
            <button @click="cancelPlan"
                    :disabled="disabelBtnCancel"
                    class="btn btn-md btn-danger">
                        Cancelar Assinatura
            </button>
        </div>
        <div class="aviso-assinatura modal-dinamic">
            <button @click="closeModal" class="btn btn-md btn-primary">Ok</button>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            newPassword: null,
            newPasswordConfirmation: null,
            passwordIsMatching: null,
            reason: null,
            disabelBtnCancel:false,
        };
    },
    methods: {
        closeModal() {
            closeModal();
        },
        changePassword() {
            axios.patch('/account', {
                password: this.newPassword,
                password_confirmation: this.newPasswordConfirmation,
            }).then(() => {
                closeModal();
                toastr.success('Senha alterada com sucesso');
            })
            .catch(() => {
                closeModal();
                toastr.error('Erro ao alterar a senha');
            });
        },
        deleteAccount() {
            axios.delete('/account', {
                data:{reason: this.reason,}
                })
                .then(() => {
                closeModal();
                    toastr.success('Sua conta foi deletada com sucesso');
                    location.href = '/login';
                })
                .catch(() => {
                    closeModal();
                    toastr.error('Erro ao alterar a senha');
                });
        },
        cancelPlan() {
            this.disabelBtnCancel = true;
            axios.patch('/financeiro/cancel-recurrent', {
                data:{reason: this.reason,}
                })
                .then(() => {
                    closeModal();
                    toastr.success('Sua assinatura foi cancelada com sucesso');
                    location.href = '/minha_conta';
                })
                .catch(() => {
                    closeModal();
                    this.disabelBtnCancel = false;
                    toastr.error('Erro ao tentar cancelar sua assinatura');
                });
        },
    },
}
</script>
